import { z } from 'zod';
import { sizeSchema, coordinateSchema } from '../../../Shared.js';

var ShapeTypes = /* @__PURE__ */ ((ShapeTypes2) => {
  ShapeTypes2["ARROW"] = "arrow";
  ShapeTypes2["ARROW_BUTTON"] = "arrow_button";
  ShapeTypes2["CIRCLE"] = "circle";
  ShapeTypes2["CIRCLE_OUTLINED"] = "circle_outlined";
  ShapeTypes2["DIAGRAM_ARROW_CORNER_POINT_LEFT"] = "diagram_arrow_corner_point_left";
  ShapeTypes2["DIAGRAM_ARROW_CORNER_POINT_RIGHT"] = "diagram_arrow_corner_point_right";
  ShapeTypes2["DIAGRAM_ARROW_LEFT"] = "diagram_left";
  ShapeTypes2["DIAGRAM_ARROW_RIGHT"] = "diagram_right";
  ShapeTypes2["DIAGRAM_ARROW_UP"] = "diagram_arrow_up";
  ShapeTypes2["DIAMOND"] = "diamond";
  ShapeTypes2["DIAMOND2"] = "diamond2";
  ShapeTypes2["ELLIPSE"] = "ellipse";
  ShapeTypes2["FLOWER"] = "flower";
  ShapeTypes2["GEOMETRIC"] = "geometric";
  ShapeTypes2["PENTAGON"] = "pentagon";
  ShapeTypes2["HEART"] = "heart";
  ShapeTypes2["HEPTAGON"] = "heptagon";
  ShapeTypes2["HEXAGON"] = "hexagon";
  ShapeTypes2["KITE"] = "kite";
  ShapeTypes2["MOON"] = "moon";
  ShapeTypes2["NONAGON"] = "nonagon";
  ShapeTypes2["PIE_CHART"] = "pie_chart";
  ShapeTypes2["PLUS"] = "plus";
  ShapeTypes2["RECTANGLE"] = "rectangle";
  ShapeTypes2["RECTANGLE_OUTLINED"] = "rectangle_outlined";
  ShapeTypes2["SEMI_CIRCLE"] = "semi_circle";
  ShapeTypes2["SIGN"] = "sign";
  ShapeTypes2["SPIRAL"] = "spiral";
  ShapeTypes2["SQUARE"] = "square";
  ShapeTypes2["STAR"] = "star";
  ShapeTypes2["TREFOIL"] = "trefoil";
  ShapeTypes2["TRIANGLE"] = "triangle";
  ShapeTypes2["TRIANGLE_OUTLINED"] = "triangle_outlined";
  ShapeTypes2["TRIANGLE2"] = "triangle2";
  ShapeTypes2["VERTICAL_LINE"] = "vertical_line";
  ShapeTypes2["OCTAGON"] = "octagon";
  return ShapeTypes2;
})(ShapeTypes || {});
const shapeItemSchema = z.object({
  kind: z.literal("shape"),
  id: z.string(),
  type: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  naturalSize: sizeSchema,
  angleInRadian: z.number(),
  settings: z.object({
    cloneable: z.boolean().default(false),
    movable: z.boolean().default(false),
    hideDragHandle: z.boolean().optional()
  }).nullish().default({}),
  style: z.object({
    strokeColor: z.string().optional(),
    fillColor: z.string().optional()
  }).nullish().default({})
});

export { ShapeTypes, shapeItemSchema };
//# sourceMappingURL=Shape.js.map
